export default ({request}) => ({
    dataAnalysisResourceContributionList(data) {
        return request({
            url: '/digitalCenter/report/resourceContributionList',
            method: 'post',
            data
        })
    },
    dataAnalysisResourceUsageList(data) {
        return request({
            url: '/digitalCenter/report/resourceUsageList',
            method: 'post',
            data
        })
    },
    dataAnalysisResourceInfoUsageList(data) {
        return request({
            url: '/digitalCenter/report/resourceInfoUsageList',
            method: 'post',
            data
        })
    },
    dataAnalysisSupplierResourceList(data) {
        return request({
            url: '/digitalCenter/report/supplierResourceList',
            method: 'post',
            data
        })
    },
    dataAnalysisProjectOverallList(data) {
        return request({
            url: '/digitalCenter/report/projectOverallList',
            method: 'post',
            data
        })
    },
    dataAnalysisProjectInfoList(data) {
        return request({
            url: '/digitalCenter/report/projectInfoList',
            method: 'post',
            data
        })
    },
    dataAnalysisProjectSampleList(data) {
        return request({
            url: '/digitalCenter/report/projectSampleList',
            method: 'post',
            data
        })
    }
})
